import React from 'react';
import { LuBox, LuHeart } from "react-icons/lu";
import { FiShoppingCart } from "react-icons/fi";

const ItemDetails = ({ onNav, cartCount = 0 }) => {
    return (
        <div className="flex gap-[9px] px-[16px] pb-[14px]">
            <div
                onClick={() => onNav?.("/orders")}
                className="flex-1 relative rounded-[12px] border border-[#E8EAF0] bg-[#F4F5FF] py-[11px] px-[8px] text-center cursor-pointer"
            >
                <LuBox size={21} className="mx-auto text-[#4862EE]" />
                <p className="mt-[5px] text-[11px] font-[500] text-[#1F212E]">Orders</p>
            </div>

            <div
                onClick={() => onNav?.("/wishlist")}
                className="flex-1 relative rounded-[12px] border border-[#E8EAF0] bg-[#F4F5FF] py-[11px] px-[8px] text-center cursor-pointer"
            >
                <LuHeart size={21} className="mx-auto text-[#4862EE]" />
                <p className="mt-[5px] text-[11px] font-[500] text-[#1F212E]">Wishlist</p>
            </div>

            <div
                onClick={() => onNav?.("/cart")}
                className="flex-1 relative rounded-[12px] border border-[#E8EAF0] bg-[#F4F5FF] py-[11px] px-[8px] text-center cursor-pointer"
            >
                {cartCount > 0 && (
                    <span className="absolute top-[7px] right-[14px] min-w-[17px] h-[17px] rounded-[9px] bg-[#FF512A] text-white text-[9px] font-[500] grid place-items-center px-[4px]">{cartCount}</span>
                )}
                <FiShoppingCart size={21} className="mx-auto text-[#4862EE]" />
                <p className="mt-[5px] text-[11px] font-[500] text-[#1F212E]">Cart</p>
            </div>
        </div>
    );
};
export default ItemDetails;
